(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adcreation"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('manet-ad-creation')) return;

  const clamp = value => Math.max(0, Math.min(1, value));

  class ManetAdCreation extends HTMLElement {
    connectedCallback() {
      if (this._abort || this._mountFrame) return;

      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;

        if (this.isConnected) {
          this._mount();
        }
      });
    }

    _mount() {
      this._abort = new AbortController();

      const signal = this._abort.signal;

      this._on = (target, type, handler, options = {}) => {
        target.addEventListener(type, handler, {
          ...options,
          signal
        });
      };

      this._motion = matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      this._setupHero();
      this._setupGallery();

      const groups = [
        this._hero,
        this._gallery
      ].filter(Boolean);

      const sync = () => {
        this._syncHero();
        this._syncGallery();
      };

      if ('IntersectionObserver' in window) {
        this._intersection = new IntersectionObserver(
          entries => {
            if (signal.aborted) return;

            entries.forEach(entry => {
              const group = groups.find(
                item => item.view === entry.target
              );

              if (group) {
                group.visible =
                  entry.isIntersecting &&
                  entry.intersectionRatio >= .05;
              }
            });

            sync();
          },
          {
            threshold: [0, .05]
          }
        );

        groups.forEach(group => {
          this._intersection.observe(group.view);
        });
      } else {
        groups.forEach(group => {
          group.visible = true;
        });

        sync();
      }

      this._on(
        document,
        'visibilitychange',
        sync
      );

      this._on(
        this._motion,
        'change',
        () => {
          if (this._motion.matches) {
            groups.forEach(group => {
              group.wanted = false;
            });
          }

          sync();
          this._scheduleReveal(true);
        }
      );

      this._setupReveal();
    }

    _setupHero() {
      const host = this.querySelector(
        '[data-ma-hero]'
      );

      const video = host?.querySelector(
        '[data-ma-hero-video]'
      );

      const toggle = host?.querySelector(
        '[data-ma-hero-toggle]'
      );

      if (!video || !toggle) return;

      const hero = this._hero = {
        host,
        view: host,
        video,
        toggle,
        visible: false,
        wanted: !this._motion.matches,
        pending: false,
        token: 0,
        error: host.querySelector(
          '[data-ma-error]'
        )
      };

      video.muted = true;
      video.playsInline = true;
      video.controls = false;

      toggle.hidden = false;

      this._on(
        toggle,
        'click',
        () => {
          hero.wanted = !hero.wanted;
          this._syncHero();
        }
      );

      this._on(
        video,
        'playing',
        () => {
          if (!this._eligible(hero)) {
            video.pause();
          }

          this._paintHero();
        }
      );

      this._on(
        video,
        'pause',
        () => this._paintHero()
      );

      this._on(
        video,
        'error',
        () => {
          hero.wanted = false;
          this._syncHero();
        }
      );

      this._paintHero();
    }

    _eligible(group) {
      return (
        group.wanted &&
        group.visible &&
        !document.hidden
      );
    }

    _syncHero() {
      const hero = this._hero;

      if (!hero) return;

      const { video } = hero;

      if (
        !this._eligible(hero) ||
        video.error
      ) {
        hero.token++;
        hero.pending = false;
        video.pause();
      } else if (
        video.paused &&
        !hero.pending
      ) {
        const token = ++hero.token;
        const signal = this._abort.signal;

        hero.pending = true;

        let attempt;

        try {
          attempt = video.play();
        } catch (error) {
          attempt = Promise.reject(error);
        }

        Promise.resolve(attempt).then(
          () => {
            if (
              signal.aborted ||
              token !== hero.token
            ) {
              return;
            }

            hero.pending = false;

            if (!this._eligible(hero)) {
              video.pause();
            }

            this._paintHero();
          },
          () => {
            if (
              signal.aborted ||
              token !== hero.token
            ) {
              return;
            }

            hero.pending = false;
            hero.wanted = false;

            this._paintHero();
          }
        );
      }

      this._paintHero();
    }

    _paintHero() {
      const hero = this._hero;

      if (!hero) return;

      hero.toggle.textContent =
        hero.wanted ? 'Pause' : 'Play';

      hero.toggle.setAttribute(
        'aria-label',
        hero.wanted
          ? 'Pause video'
          : 'Play video'
      );

      if (hero.error) {
        hero.error.hidden =
          !hero.video.error;

        hero.error.textContent =
          hero.video.error
            ? 'Video unavailable. Please try again later.'
            : '';
      }
    }

    _setupGallery() {
      const host = this.querySelector(
        '[data-ma-gallery]'
      );

      if (!host) return;

      const slides = [
        ...host.querySelectorAll(
          '[data-ma-slide]'
        )
      ];

      const dots = [
        ...host.querySelectorAll(
          '[data-ma-dot]'
        )
      ];

      const images = slides.map(
        slide => slide.querySelector('img')
      );

      const toggle = host.querySelector(
        '[data-ma-gallery-toggle]'
      );

      const ui = host.querySelector(
        '[data-ma-gallery-ui]'
      );

      if (
        !toggle ||
        !ui ||
        !slides.length ||
        images.some(img => !img) ||
        dots.length !== slides.length
      ) {
        return;
      }

      const g = this._gallery = {
        host,
        view:
          host.querySelector(
            '[data-ma-stage]'
          ) || host,
        slides,
        dots,
        images,
        toggle,
        ui,
        index: 0,
        interval: Math.max(
          2000,
          Number(
            host.dataset.maInterval
          ) || 6000
        ),
        elapsed: 0,
        wanted:
          !this._motion.matches,
        visible: false,
        hoverHold: false,
        focusHold: false,
        frame: 0,
        stamp: null,
        token: 0,
        requested: false,
        pending: false,
        ready: false,
        failed: false,
        error: host.querySelector(
          '[data-ma-error]'
        ),
        status: host.querySelector(
          '[data-ma-status]'
        )
      };

      this._on(
        toggle,
        'click',
        () => {
          g.wanted = !g.wanted;

          if (g.wanted) {
            g.hoverHold = false;
            g.focusHold = false;
          }

          this._syncGallery();
        }
      );

      const select = index =>
        this._selectGallery(
          index,
          true
        );

      dots.forEach(
        (dot, index) => {
          this._on(
            dot,
            'click',
            () => select(index)
          );
        }
      );

      ['prev', 'next'].forEach(
        (name, index) => {
          const button =
            host.querySelector(
              `[data-ma-${name}]`
            );

          if (button) {
            this._on(
              button,
              'click',
              () => {
                select(
                  g.index +
                    (index ? 1 : -1)
                );
              }
            );
          }
        }
      );

      this._on(
        host,
        'keydown',
        event => {
          if (
            event.altKey ||
            event.ctrlKey ||
            event.metaKey ||
            event.target.closest(
              'input,textarea,select,[contenteditable]'
            )
          ) {
            return;
          }

          if (
            event.key ===
              'ArrowLeft' ||
            event.key ===
              'ArrowRight'
          ) {
            event.preventDefault();

            select(
              g.index +
                (
                  event.key ===
                  'ArrowRight'
                    ? 1
                    : -1
                )
            );
          }
        }
      );

      this._on(
        host,
        'pointerenter',
        event => {
          if (
            event.pointerType ===
            'mouse'
          ) {
            g.hoverHold = true;
            this._syncGallery();
          }
        }
      );

      this._on(
        host,
        'pointerleave',
        () => {
          g.hoverHold = false;
          this._syncGallery();
        }
      );

      this._on(
        host,
        'focusin',
        event => {
          if (
            !host.contains(
              event.relatedTarget
            )
          ) {
            g.focusHold = true;
            this._syncGallery();
          }
        }
      );

      this._on(
        host,
        'focusout',
        event => {
          if (
            !host.contains(
              event.relatedTarget
            )
          ) {
            g.focusHold = false;
            this._syncGallery();
          }
        }
      );

      const stage =
        host.querySelector(
          '[data-ma-stage]'
        );

      if (stage) {
        let swipe;

        this._on(
          stage,
          'pointerdown',
          event => {
            swipe =
              event.pointerType !==
                'mouse' &&
              !event.target.closest(
                'a,button,input'
              )
                ? {
                    id:
                      event.pointerId,
                    x:
                      event.clientX,
                    y:
                      event.clientY
                  }
                : null;
          },
          {
            passive: true
          }
        );

        this._on(
          stage,
          'pointerup',
          event => {
            if (
              !swipe ||
              swipe.id !==
                event.pointerId
            ) {
              return;
            }

            const dx =
              event.clientX -
              swipe.x;

            const dy =
              event.clientY -
              swipe.y;

            swipe = null;

            if (
              Math.abs(dx) > 50 &&
              Math.abs(dx) >
                Math.abs(dy) * 1.5
            ) {
              select(
                g.index +
                  (dx < 0 ? 1 : -1)
              );
            }
          },
          {
            passive: true
          }
        );

        this._on(
          stage,
          'pointercancel',
          () => {
            swipe = null;
          }
        );
      }

      images.forEach(
        (img, index) => {
          this._on(
            img,
            'load',
            () => {
              if (
                index === g.index &&
                g.requested
              ) {
                this._decodeImage();
              }
            }
          );

          this._on(
            img,
            'error',
            () => {
              if (
                index === g.index &&
                g.requested
              ) {
                this._imageFailed();
              }
            }
          );
        }
      );

      ui.hidden = false;

      this._selectGallery(
        0,
        false
      );
    }

    _selectGallery(index, manual) {
      const g = this._gallery;

      this._stopGallery();

      g.index =
        (
          index +
          g.slides.length
        ) %
        g.slides.length;

      g.token++;
      g.elapsed = 0;
      g.requested = false;
      g.pending = false;
      g.ready = false;
      g.failed = false;

      g.slides.forEach(
        (slide, number) => {
          slide.hidden =
            number !== g.index;
        }
      );

      if (
        manual &&
        g.status
      ) {
        g.status.textContent =
          `Image ${g.index + 1} of ${g.slides.length}: ` +
          `${
            g.slides[g.index]
              .dataset.title ||
            'Selected work'
          }`;
      }

      this._syncGallery();
    }

    _decodeImage() {
      const g = this._gallery;

      if (
        g.pending ||
        g.ready ||
        g.failed
      ) {
        return;
      }

      const img =
        g.images[g.index];

      const token = g.token;
      const signal =
        this._abort.signal;

      g.pending = true;

      let decoded;

      try {
        decoded = img.decode
          ? img.decode()
          : Promise.resolve();
      } catch (error) {
        decoded =
          Promise.reject(error);
      }

      Promise.resolve(decoded).then(
        () => {
          if (
            signal.aborted ||
            token !== g.token
          ) {
            return;
          }

          g.pending = false;

          if (!img.naturalWidth) {
            return this._imageFailed();
          }

          g.ready = true;

          this._syncGallery();
        },
        () => {
          if (
            !signal.aborted &&
            token === g.token
          ) {
            this._imageFailed();
          }
        }
      );
    }

    _imageFailed() {
      const g = this._gallery;

      g.token++;
      g.failed = true;
      g.pending = false;
      g.ready = false;
      g.wanted = false;

      this._syncGallery();
    }

    _syncGallery() {
      const g = this._gallery;

      if (!g) return;

      this._stopGallery();

      if (
        g.visible &&
        !document.hidden &&
        !g.requested &&
        !g.failed
      ) {
        const img =
          g.images[g.index];

        g.requested = true;
        img.loading = 'eager';

        if (img.complete) {
          if (img.naturalWidth) {
            this._decodeImage();
          } else {
            this._imageFailed();
          }
        }
      }

      if (
        g.ready &&
        this._eligible(g) &&
        !g.hoverHold &&
        !g.focusHold
      ) {
        g.stamp =
          performance.now();

        g.frame =
          requestAnimationFrame(
            now =>
              this._tickGallery(
                now
              )
          );
      }

      this._paintGallery();
    }

    _stopGallery() {
      const g = this._gallery;

      if (!g) return;

      if (g.stamp !== null) {
        g.elapsed =
          Math.min(
            g.interval,
            g.elapsed +
              performance.now() -
              g.stamp
          );
      }

      g.stamp = null;

      cancelAnimationFrame(
        g.frame
      );

      g.frame = 0;
    }

    _tickGallery(now) {
      const g = this._gallery;

      if (
        !g ||
        g.stamp === null
      ) {
        return;
      }

      g.elapsed =
        Math.min(
          g.interval,
          g.elapsed +
            Math.max(
              0,
              now - g.stamp
            )
        );

      g.stamp = now;
      g.frame = 0;

      if (
        g.elapsed >=
        g.interval
      ) {
        return this._selectGallery(
          g.index + 1,
          false
        );
      }

      this._paintGallery();

      g.frame =
        requestAnimationFrame(
          time => {
            this._tickGallery(
              time
            );
          }
        );
    }

    _paintGallery() {
      const g = this._gallery;

      g.toggle.textContent =
        g.wanted
          ? 'Pause'
          : 'Play';

      g.toggle.setAttribute(
        'aria-label',
        g.wanted
          ? 'Pause automatic slideshow'
          : 'Play automatic slideshow'
      );

      g.toggle.disabled =
        g.failed;

      g.dots.forEach(
        (dot, index) => {
          if (
            index === g.index
          ) {
            dot.setAttribute(
              'aria-current',
              'true'
            );
          } else {
            dot.removeAttribute(
              'aria-current'
            );
          }

          const fill =
            dot.querySelector(
              '[data-ma-fill]'
            );

          if (fill) {
            const progress =
              index < g.index
                ? 1
                : index ===
                  g.index
                  ? clamp(
                      g.elapsed /
                      g.interval
                    )
                  : 0;

            fill.style.transform =
              `scaleX(${progress})`;
          }
        }
      );

      if (g.error) {
        g.error.hidden =
          !g.failed;

        g.error.textContent =
          g.failed
            ? 'Image unavailable. Choose another frame.'
            : '';
      }
    }

    _setupReveal() {
      this._paragraph =
        this.querySelector(
          '[data-ma-reveal]'
        );

      if (!this._paragraph) {
        return;
      }

      const fragment =
        document.createDocumentFragment();

      this._revealText =
        this._paragraph
          .textContent
          .trim();

      this._words =
        this._revealText
          .split(/\s+/)
          .map(
            (word, index) => {
              if (index) {
                fragment.append(
                  document.createTextNode(
                    ' '
                  )
                );
              }

              const span =
                document.createElement(
                  'span'
                );

              span.className =
                'ma-word';

              span.textContent =
                word;

              fragment.append(
                span
              );

              return span;
            }
          );

      this._paragraph
        .replaceChildren(
          fragment
        );

      this._on(
        window,
        'scroll',
        () =>
          this._scheduleReveal(),
        {
          passive: true
        }
      );

      this._on(
        window,
        'resize',
        () =>
          this._scheduleReveal(
            true
          ),
        {
          passive: true
        }
      );

      if (
        'ResizeObserver' in
        window
      ) {
        this._resize =
          new ResizeObserver(
            () =>
              this._scheduleReveal(
                true
              )
          );

        this._resize.observe(
          this._paragraph
        );
      }

      const signal =
        this._abort.signal;

      document.fonts?.ready.then(
        () => {
          if (
            !signal.aborted
          ) {
            this._scheduleReveal(
              true
            );
          }
        }
      );

      this._scheduleReveal(true);
    }

    _scheduleReveal(
      measure = false
    ) {
      if (!this._paragraph) {
        return;
      }

      this._needsMeasure ||=
        measure;

      if (this._revealFrame) {
        return;
      }

      this._revealFrame =
        requestAnimationFrame(
          () => {
            this._revealFrame = 0;

            if (
              this._needsMeasure
            ) {
              this._rows = [];

              this._words.forEach(
                span => {
                  const rect =
                    span.getBoundingClientRect();

                  let row =
                    this._rows[
                      this._rows
                        .length - 1
                    ];

                  if (
                    !row ||
                    Math.abs(
                      row.top -
                        rect.top
                    ) > 2
                  ) {
                    row = {
                      top: rect.top,
                      left:
                        rect.left,
                      right:
                        rect.right,
                      words: []
                    };

                    this._rows.push(
                      row
                    );
                  }

                  row.right =
                    Math.max(
                      row.right,
                      rect.right
                    );

                  row.words.push(
                    {
                      span,
                      left:
                        rect.left,
                      width:
                        rect.width
                    }
                  );
                }
              );

              this._needsMeasure =
                false;
            }

            const rect =
              this._paragraph
                .getBoundingClientRect();

            const viewport =
              window.innerHeight;

            const progress =
              this._motion.matches
                ? 1
                : clamp(
                    (
                      viewport *
                        .82 -
                      rect.top
                    ) /
                    (
                      rect.height +
                      viewport *
                        .27
                    )
                  );

            this._rows.forEach(
              (row, index) => {
                const edge =
                  row.left +
                  (
                    row.right -
                    row.left
                  ) *
                  clamp(
                    progress *
                      this._rows
                        .length -
                      index
                  );

                row.words.forEach(
                  word => {
                    word.span
                      .style
                      .setProperty(
                        '--ma-ink',
                        `${
                          (
                            clamp(
                              (
                                edge -
                                word.left
                              ) /
                              (
                                word.width ||
                                1
                              )
                            ) *
                            100
                          ).toFixed(
                            2
                          )
                        }%`
                      );
                  }
                );
              }
            );
          }
        );
    }

    disconnectedCallback() {
      cancelAnimationFrame(
        this._mountFrame
      );

      cancelAnimationFrame(
        this._revealFrame
      );

      this._mountFrame = 0;
      this._revealFrame = 0;

      this._abort?.abort();

      this._intersection
        ?.disconnect();

      this._resize
        ?.disconnect();

      this._stopGallery();

      if (this._gallery) {
        this._gallery.ui.hidden =
          true;
      }

      if (this._hero) {
        this._hero.video.pause();
        this._hero.video.controls =
          true;
        this._hero.toggle.hidden =
          true;
      }

      if (this._paragraph) {
        this._paragraph.textContent =
          this._revealText;
      }

      this._abort = null;
      this._hero = null;
      this._gallery = null;
      this._paragraph = null;
    }
  }

  customElements.define(
    'manet-ad-creation',
    ManetAdCreation
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.capital-operations-section');
  if (section) {
    console.log('Capital Operations Panel loaded');
    
    // Button interaction
    const ctaButton = document.querySelector('.capital-operations-cta');
    if (ctaButton) {
      ctaButton.addEventListener('click', function() {
        window.open('https://altairpartner.com/pages/apply-to-join-affiliate-program', '_blank');
      });
    }
    
    // Animate status values
    const statusValues = document.querySelectorAll('.capital-operations-status-value');
    if (statusValues.length > 0) {
      // Simulate earnings growth
      const earningsElement = document.querySelector('.capital-operations-status-value[data-type="earnings"]');
      if (earningsElement) {
        let earnings = 0;
        const interval = setInterval(() => {
          earnings += Math.random() * 100;
          earningsElement.textContent = `$${earnings.toFixed(2)} → ∞`;
          
          if (earnings > 10000) {
            clearInterval(interval);
          }
        }, 1500);
      }
      
      // Simulate status verification
      const statusElement = document.querySelector('.capital-operations-status-value[data-type="status"]');
      if (statusElement) {
        setTimeout(() => {
          statusElement.textContent = "VERIFIED";
          statusElement.style.color = "#00FF00";
        }, 3000);
      }
    }
    
    // Animate global status panel
    const globalStatus = document.querySelector('.capital-operations-global-status');
    if (globalStatus) {
      const regions = ["EMEA", "APAC", "AMER", "GLOBAL"];
      const currencies = ["USD", "AED", "GBP", "EUR", "JPY", "CNY"];
      const nodes = ["ALT∆IR/CAPITAL", "ALT∆IR/NODE-09", "ALT∆IR/EXEC", "ALT∆IR/GLOBAL"];
      
      let currentRegion = 0;
      let currentCurrency = 0;
      let currentNode = 0;
      
      setInterval(() => {
        currentRegion = (currentRegion + 1) % regions.length;
        currentCurrency = (currentCurrency + 1) % currencies.length;
        currentNode = (currentNode + 1) % nodes.length;
        
        globalStatus.innerHTML = `
          <div>[ REGION: ${regions[currentRegion]} ]</div>
          <div>[ CURRENCY: ${currencies[currentCurrency]} ]</div>
          <div>[ NODE: ${nodes[currentNode]} ]</div>
        `;
      }, 3000);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.operational-layer');
  if (section) {
    console.log('Operational Layer loaded');
    
    // Live feed animation
    const feedContent = document.querySelector('.feed-content');
    if (feedContent) {
      const contractors = [
        "CTR-001", "CTR-005", "CTR-009", "CTR-012", 
        "CTR-018", "CTR-022", "CTR-027", "CTR-033"
      ];
      
      const clients = [
        "CL-5421", "CL-7812", "CL-3098", "CL-4567",
        "CL-6723", "CL-1289", "CL-9054", "CL-3345"
      ];
      
      const actions = [
        "sent notification to", "connected with", "initiated contact with",
        "assigned project to", "scheduled call with", "shared documents with",
        "created agreement for", "completed onboarding for"
      ];
      
      const statuses = [
        "via secure link", "through partner portal", "via encrypted channel",
        "using verification code", "through direct access", "via private gateway"
      ];
      
      function generateFeedLine() {
        const contractor = contractors[Math.floor(Math.random() * contractors.length)];
        const client = clients[Math.floor(Math.random() * clients.length)];
        const action = actions[Math.floor(Math.random() * actions.length)];
        const status = statuses[Math.floor(Math.random() * statuses.length)];
        
        return `<span class="contractor">${contractor}</span> <span class="action">${action}</span> <span class="client">${client}</span> <span class="action">${status}</span>`;
      }
      
      function addFeedLine() {
        const line = document.createElement('div');
        line.className = 'feed-line';
        line.innerHTML = generateFeedLine();
        feedContent.appendChild(line);
        
        // Remove oldest line if too many
        if (feedContent.children.length > 8) {
          feedContent.removeChild(feedContent.children[0]);
        }
        
        setTimeout(addFeedLine, Math.random() * 3000 + 1500);
      }
      
      // Start with 3 lines immediately
      for (let i = 0; i < 3; i++) {
        addFeedLine();
      }
    }
    
    // Initiate button interaction
    const initiateBtn = document.querySelector('.initiate-btn');
    if (initiateBtn) {
      initiateBtn.addEventListener('click', function() {
        const partnerId = document.querySelector('.partner-input').value;
        if (partnerId.trim() !== '') {
          initiateBtn.textContent = "CONNECTING...";
          setTimeout(() => {
            initiateBtn.textContent = "CONNECTION ESTABLISHED";
            setTimeout(() => {
              initiateBtn.textContent = "▶ INITIATE";
            }, 2000);
          }, 1500);
        } else {
          initiateBtn.textContent = "ID REQUIRED";
          setTimeout(() => {
            initiateBtn.textContent = "▶ INITIATE";
          }, 1000);
        }
      });
    }
    
    // Disclaimer toggle
    const disclaimerBtn = document.querySelector('.disclaimer-btn');
    const disclaimerText = document.querySelector('.disclaimer-text');
    
    if (disclaimerBtn && disclaimerText) {
      disclaimerBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        disclaimerText.classList.toggle('active');
      });
      
      // Close disclaimer when clicking outside
      document.addEventListener('click', function(event) {
        if (!disclaimerBtn.contains(event.target) && !disclaimerText.contains(event.target)) {
          disclaimerText.classList.remove('active');
        }
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliateprogram"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const formContainer = document.querySelector('.affiliate-form-container');
  if (!formContainer) return;

  // Performance optimization: Defer non-critical JavaScript
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initForm);
  } else {
    setTimeout(initForm, 0);
  }

  function initForm() {
    // Form steps management
    const steps = document.querySelectorAll('.form-step');
    const nextButtons = document.querySelectorAll('[data-next-step]');
    const progressFill = document.querySelector('.progress-fill');
    const progressText = document.querySelector('.progress-text');
    const totalSteps = steps.length;
    
    let currentStep = 0;
    
    // Initialize form
    updateProgress();
    showStep(currentStep);
    
    // Next button click handler
    nextButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Add loading state for better UX
        this.classList.add('loading');
        
        // Validate current step before proceeding
        setTimeout(() => {
          if (validateStep(currentStep)) {
            currentStep++;
            updateProgress();
            showStep(currentStep);
            
            // If this is the final step (submit), submit the form
            if (currentStep === totalSteps - 1) {
              handleFormSubmission();
            }
          }
          this.classList.remove('loading');
        }, 300);
      });
    });
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      // Enter key to progress (except in textareas)
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        const activeStep = document.querySelector('.form-step.active');
        const nextButton = activeStep.querySelector('[data-next-step]');
        if (nextButton) {
          e.preventDefault();
          nextButton.click();
        }
      }
      
      // Escape key to reset form
      if (e.key === 'Escape') {
        resetForm();
      }
    });
    
    // Improved focus management for accessibility
    function manageFocus() {
      const activeStep = document.querySelector('.form-step.active');
      const firstInput = activeStep.querySelector('input, button, textarea');
      if (firstInput) {
        firstInput.focus();
      }
    }
    
    function showStep(stepIndex) {
      steps.forEach((step, index) => {
        if (index === stepIndex) {
          step.classList.add('active');
          step.setAttribute('aria-hidden', 'false');
        } else {
          step.classList.remove('active');
          step.setAttribute('aria-hidden', 'true');
        }
      });
      
      // Update ARIA live region for screen readers
      updateAriaLive(stepIndex);
      
      // Manage focus for better accessibility
      setTimeout(manageFocus, 100);
    }
    
    function updateProgress() {
      const progressPercentage = (currentStep / (totalSteps - 1)) * 100;
      if (progressFill) {
        progressFill.style.width = `${progressPercentage}%`;
      }
      if (progressText) {
        progressText.textContent = `${Math.round(progressPercentage)}% COMPLETE`;
      }
      
      // Update ARIA attributes for progress bar
      if (progressFill) {
        progressFill.setAttribute('aria-valuenow', Math.round(progressPercentage));
        progressFill.setAttribute('aria-valuetext', `${Math.round(progressPercentage)}% complete`);
      }
    }
    
    function validateStep(stepIndex) {
      let isValid = true;
      
      // Hide all error messages first
      document.querySelectorAll('.error-message').forEach(el => {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      });
      
      // Step-specific validation
      switch(stepIndex) {
        case 1: // Age confirmation step
          const ageCheckbox = document.getElementById('age-confirmation');
          if (!ageCheckbox.checked) {
            const ageError = document.querySelector('#age-error');
            ageError.style.display = 'block';
            ageError.setAttribute('aria-hidden', 'false');
            ageCheckbox.focus();
            isValid = false;
          }
          break;
          
        case 2: // Main form step
          const privacyCheckbox = document.getElementById('privacy-agreement');
          if (!privacyCheckbox.checked) {
            const privacyError = document.querySelector('#privacy-error');
            privacyError.style.display = 'block';
            privacyError.setAttribute('aria-hidden', 'false');
            if (isValid) privacyCheckbox.focus();
            isValid = false;
          }
          
          const newsletterCheckbox = document.getElementById('newsletter-agreement');
          if (!newsletterCheckbox.checked) {
            const newsletterError = document.querySelector('#newsletter-error');
            newsletterError.style.display = 'block';
            newsletterError.setAttribute('aria-hidden', 'false');
            if (isValid) newsletterCheckbox.focus();
            isValid = false;
          }
          
          const emailInput = document.getElementById('ContactForm-email');
          if (!emailInput.value || !emailInput.checkValidity()) {
            const emailError = document.querySelector('#email-error');
            emailError.style.display = 'block';
            emailError.setAttribute('aria-hidden', 'false');
            if (isValid) emailInput.focus();
            isValid = false;
          }
          
          const nameInput = document.getElementById('ContactForm-name');
          if (!nameInput.value) {
            const nameError = document.querySelector('#name-error');
            nameError.style.display = 'block';
            nameError.setAttribute('aria-hidden', 'false');
            if (isValid) nameInput.focus();
            isValid = false;
          }
          break;
      }
      
      return isValid;
    }
    
    function handleFormSubmission() {
      const form = document.getElementById('ContactForm');
      if (!form) return;
      
      // Create a FormData object
      const formData = new FormData(form);
      
      // Add loading state to submit button
      const submitButton = form.querySelector('[data-next-step]');
      if (submitButton) {
        submitButton.classList.add('loading');
        submitButton.disabled = true;
      }
      
      // Submit the form using Shopify's native form handling
      form.dispatchEvent(new Event('submit', { bubbles: true }));
      
      // Note: Shopify will handle the actual submission and validation
      // We rely on the form's native submit behavior for better compatibility
    }
    
    function resetForm() {
      currentStep = 0;
      updateProgress();
      showStep(currentStep);
      
      // Clear form data
      const form = document.getElementById('ContactForm');
      if (form) form.reset();
      
      // Clear error messages
      document.querySelectorAll('.error-message').forEach(el => {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      });
    }
    
    function updateAriaLive(stepIndex) {
      let message = '';
      switch(stepIndex) {
        case 0:
          message = 'Welcome to our affiliate program application. Step 1 of 4.';
          break;
        case 1:
          message = 'Age verification step. Step 2 of 4.';
          break;
        case 2:
          message = 'Application form step. Step 3 of 4. Please fill out your information.';
          break;
        case 3:
          message = 'Thank you for your application. Step 4 of 4 complete.';
          break;
      }
      
      // Create or update ARIA live region
      let liveRegion = document.getElementById('form-live-region');
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'form-live-region';
        liveRegion.className = 'visually-hidden';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        formContainer.appendChild(liveRegion);
      }
      
      liveRegion.textContent = message;
    }
    
    // Initialize ARIA attributes
    function initAriaAttributes() {
      // Progress bar accessibility
      if (progressFill) {
        progressFill.setAttribute('role', 'progressbar');
        progressFill.setAttribute('aria-valuemin', '0');
        progressFill.setAttribute('aria-valuemax', '100');
        progressFill.setAttribute('aria-valuenow', '0');
      }
      
      // Form steps accessibility
      steps.forEach((step, index) => {
        step.setAttribute('aria-labelledby', `step-${index}-title`);
        step.setAttribute('aria-describedby', `step-${index}-description`);
        
        const title = step.querySelector('.step-title');
        if (title) title.id = `step-${index}-title`;
        
        const description = step.querySelector('.step-description');
        if (description) description.id = `step-${index}-description`;
      });
      
      // Form labels and inputs
      const labels = document.querySelectorAll('.field__label');
      labels.forEach(label => {
        const input = document.querySelector(`#${label.getAttribute('for')}`);
        if (input && !input.getAttribute('aria-labelledby')) {
          input.setAttribute('aria-labelledby', label.id || label.getAttribute('for') + '-label');
        }
      });
    }
    
    initAriaAttributes();
  }
});

// Performance: Load fonts efficiently
if ('fonts' in document) {
  document.fonts.load('1em IBM Plex Mono');
  document.fonts.load('1em Space Mono');
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["altair_custom_section"] && !Shopify.designMode) return;
  try {
    
  // IntersectionObserver to trigger animations when cards come into view
  document.addEventListener('DOMContentLoaded', function() {
    var cards = document.querySelectorAll('#animated-impact .impact-card');
    var observerOptions = {
      threshold: 0.3
    };

    var observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          animateCount(entry.target.querySelector('.impact-number'));
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    cards.forEach(function(card) {
      observer.observe(card);
    });

    // Simple count-up animation
    function animateCount(el) {
      var target = parseFloat(el.getAttribute('data-target'));
      var suffix = el.getAttribute('data-suffix') || '';
      var current = 0;
      var increment = target / 60; // animate over ~1s (60 frames)
      function update() {
        current += increment;
        if (current >= target) {
          el.textContent = target + suffix;
        } else {
          el.textContent = Math.floor(current) + suffix;
          requestAnimationFrame(update);
        }
      }
      requestAnimationFrame(update);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["branding"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('manet-branding')) return;

  const clamp = value => Math.max(0, Math.min(1, value));

  class ManetBranding extends HTMLElement {
    connectedCallback() {
      if (this._abort || this._mountFrame) return;

      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;
        if (this.isConnected) this._mount();
      });
    }

    _mount() {
      this._abort = new AbortController();
      const signal = this._abort.signal;

      this._on = (target, event, handler, options = {}) => {
        target.addEventListener(event, handler, {
          ...options,
          signal
        });
      };

      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      this._auto =
        this.dataset.mbAutoplay === 'true' &&
        !this._motion.matches;

      this._setupHero();
      this._setupGallery();

      const groups = [this._hero, this._gallery].filter(Boolean);

      const sync = () => {
        this._syncHero();
        this._syncGallery();
      };

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          if (signal.aborted) return;

          entries.forEach(entry => {
            const group = groups.find(
              item => item.view === entry.target
            );

            if (group) {
              group.visible =
                entry.isIntersecting &&
                entry.intersectionRatio >= .05;
            }
          });

          sync();
        }, {
          threshold: [0, .05]
        });

        groups.forEach(group => {
          this._observer.observe(group.view);
        });
      } else {
        groups.forEach(group => {
          group.visible = true;
        });

        sync();
      }

      this._on(document, 'visibilitychange', sync);

      this._on(this._motion, 'change', () => {
        if (this._motion.matches) {
          groups.forEach(group => {
            group.wanted = false;
          });
        }

        sync();
        this._scheduleReveal(true);
      });

      this._setupReveal();
    }

    _allowed(group) {
      return (
        group.wanted &&
        group.visible &&
        !document.hidden &&
        !group.hoverHold &&
        !group.focusHold &&
        !group.editorHold
      );
    }

    _play(group, video) {
      if (!video.paused || group.pending) return;

      const token = ++group.playToken;
      const signal = this._abort.signal;

      group.pending = true;

      let attempt;

      try {
        attempt = video.play();
      } catch (error) {
        attempt = Promise.reject(error);
      }

      Promise.resolve(attempt).then(() => {
        if (
          signal.aborted ||
          token !== group.playToken
        ) return;

        group.pending = false;

        if (!this._allowed(group)) video.pause();

        this._paintHero();
        this._paintGallery();
      }, () => {
        if (
          signal.aborted ||
          token !== group.playToken
        ) return;

        group.pending = false;
        group.wanted = false;

        this._paintHero();
        this._paintGallery();
      });
    }

    _pause(group, video) {
      group.playToken++;
      group.pending = false;

      if (video && !video.paused) video.pause();
    }

    /* HERO VIDEO */

    _setupHero() {
      const host = this.querySelector('[data-mb-hero]');
      const video = host?.querySelector('video');
      const toggle = host?.querySelector('[data-mb-hero-toggle]');

      if (!video || !toggle) return;

      const h = this._hero = {
        view: host,
        video,
        toggle,
        visible: false,
        wanted: this._auto,
        playToken: 0,
        pending: false,
        error: host.querySelector('[data-mb-error]')
      };

      video.muted = true;
      video.controls = false;
      toggle.hidden = false;

      this._on(toggle, 'click', () => {
        h.wanted = !h.wanted;
        this._syncHero();
      });

      this._on(video, 'playing', () => {
        if (!this._allowed(h)) video.pause();
        this._paintHero();
      });

      this._on(video, 'pause', () => {
        this._paintHero();
      });

      this._on(video, 'error', () => {
        h.wanted = false;
        this._syncHero();
      });

      this._paintHero();
    }

    _syncHero() {
      const h = this._hero;
      if (!h) return;

      if (this._allowed(h) && !h.video.error) {
        this._play(h, h.video);
      } else {
        this._pause(h, h.video);
      }

      this._paintHero();
    }

    _paintHero() {
      const h = this._hero;
      if (!h) return;

      h.toggle.textContent = h.wanted ? 'Pause' : 'Play';

      h.toggle.setAttribute(
        'aria-label',
        h.wanted ? 'Pause video' : 'Play video'
      );

      if (h.error) {
        h.error.hidden = !h.video.error;
        h.error.textContent = h.video.error
          ? 'Video unavailable. Please try again later.'
          : '';
      }
    }

    /* MIXED IMAGE / VIDEO GALLERY */

    _setupGallery() {
      const host = this.querySelector('[data-mb-gallery]');
      if (!host) return;

      const slides = [
        ...host.querySelectorAll('[data-mb-slide]')
      ];

      const dots = [
        ...host.querySelectorAll('[data-mb-dot]')
      ];

      const toggle = host.querySelector('[data-mb-gallery-toggle]');
      const ui = host.querySelector('[data-mb-gallery-ui]');

      if (
        !slides.length ||
        dots.length !== slides.length ||
        !toggle ||
        !ui
      ) return;

      const g = this._gallery = {
        host,
        slides,
        dots,
        toggle,
        ui,
        view: host.querySelector('[data-mb-stage]'),
        media: slides.map(slide =>
          slide.querySelector('video') ||
          slide.querySelector('img')
        ),
        index: 0,
        elapsed: 0,
        stamp: null,
        frame: 0,
        version: 0,
        interval: Math.max(
          2000,
          Number(host.dataset.mbInterval) || 6000
        ),
        wanted: this._auto,
        visible: false,
        hoverHold: false,
        focusHold: false,
        editorHold: false,
        playToken: 0,
        pending: false,
        ready: false,
        decoding: false,
        requested: false,
        failed: false,
        error: host.querySelector('[data-mb-error]'),
        status: host.querySelector('[data-mb-status]')
      };

      this._on(toggle, 'click', () => {
        g.wanted = !g.wanted;

        if (g.wanted) {
          g.hoverHold = false;
          g.focusHold = false;

          const video = this._currentVideo();

          if (video?.ended) {
            video.currentTime = 0;
          }
        }

        this._syncGallery();
      });

      dots.forEach((dot, index) => {
        this._on(dot, 'click', () => {
          this._select(index, true);
        });
      });

      ['prev', 'next'].forEach((name, index) => {
        const button = host.querySelector(`[data-mb-${name}]`);
        if (!button) return;

        button.disabled = slides.length < 2;

        this._on(button, 'click', () => {
          this._select(
            g.index + (index ? 1 : -1),
            true
          );
        });
      });

      this._on(host, 'keydown', event => {
        if (
          event.altKey ||
          event.ctrlKey ||
          event.metaKey ||
          event.target.closest(
            'input,textarea,select,[contenteditable]'
          )
        ) return;

        if (
          event.key === 'ArrowLeft' ||
          event.key === 'ArrowRight'
        ) {
          event.preventDefault();

          this._select(
            g.index + (event.key === 'ArrowRight' ? 1 : -1),
            true
          );
        }
      });

      this._on(host, 'pointerenter', event => {
        if (event.pointerType === 'mouse') {
          g.hoverHold = true;
          this._syncGallery();
        }
      });

      this._on(host, 'pointerleave', () => {
        g.hoverHold = false;
        this._syncGallery();
      });

      this._on(host, 'focusin', event => {
        if (!host.contains(event.relatedTarget)) {
          g.focusHold = true;
          this._syncGallery();
        }
      });

      this._on(host, 'focusout', event => {
        if (!host.contains(event.relatedTarget)) {
          g.focusHold = false;
          this._syncGallery();
        }
      });

      let swipe;

      this._on(g.view, 'pointerdown', event => {
        swipe = event.pointerType !== 'mouse'
          ? {
              id: event.pointerId,
              x: event.clientX,
              y: event.clientY
            }
          : null;
      }, {
        passive: true
      });

      this._on(g.view, 'pointerup', event => {
        if (!swipe || swipe.id !== event.pointerId) return;

        const dx = event.clientX - swipe.x;
        const dy = event.clientY - swipe.y;

        swipe = null;

        if (
          Math.abs(dx) > 50 &&
          Math.abs(dx) > Math.abs(dy) * 1.5
        ) {
          this._select(
            g.index + (dx < 0 ? 1 : -1),
            true
          );
        }
      }, {
        passive: true
      });

      this._on(g.view, 'pointercancel', () => {
        swipe = null;
      });

      g.media.forEach((media, index) => {
        if (!media) return;

        this._on(media, 'error', () => {
          if (index === g.index) this._fail();
        });

        if (media.tagName === 'IMG') {
          this._on(media, 'load', () => {
            if (index === g.index && g.requested) {
              this._decode();
            }
          });

          return;
        }

        media.muted = true;
        media.controls = false;
        media.loop = false;

        this._on(media, 'playing', () => {
          if (
            index !== g.index ||
            !this._allowed(g)
          ) {
            return media.pause();
          }

          this._startClock();
        });

        ['pause', 'waiting'].forEach(event => {
          this._on(media, event, () => {
            if (index === g.index) {
              this._stopClock();
              this._paintGallery();
            }
          });
        });

        this._on(media, 'loadedmetadata', () => {
          if (index !== g.index) return;

          if (g.resetVideo) {
            media.currentTime = 0;
            g.resetVideo = false;
          }

          this._paintGallery();
        });

        [
          'timeupdate',
          'durationchange',
          'seeked'
        ].forEach(event => {
          this._on(media, event, () => {
            if (index === g.index) {
              this._paintGallery();
            }
          });
        });

        this._on(media, 'ended', () => {
          if (index !== g.index) return;

          this._stopClock();

          if (
            this._allowed(g) &&
            !this._motion.matches &&
            slides.length > 1
          ) {
            this._select(g.index + 1, false);
          } else {
            g.wanted = false;
            this._paintGallery();
          }
        });
      });

      /*
        Show and pause the selected slide in the Shopify theme editor.
      */

      this._on(document, 'shopify:block:select', event => {
        const index = slides.findIndex(slide =>
          slide.dataset.blockId === event.detail?.blockId
        );

        if (index < 0) return;

        g.editorHold = true;
        this._select(index, true);
      });

      this._on(document, 'shopify:block:deselect', event => {
        const belongsHere = slides.some(slide =>
          slide.dataset.blockId === event.detail?.blockId
        );

        if (!belongsHere) return;

        g.editorHold = false;
        this._syncGallery();
      });

      ui.hidden = false;
      this._select(0, false);
    }

    _currentVideo() {
      const media = this._gallery?.media[this._gallery.index];

      return media?.tagName === 'VIDEO'
        ? media
        : null;
    }

    _select(index, manual) {
      const g = this._gallery;

      this._stopClock();
      this._pause(g, this._currentVideo());

      g.media.forEach(media => {
        if (media?.tagName === 'VIDEO') media.pause();
      });

      g.index =
        (index + g.slides.length) %
        g.slides.length;

      g.version++;
      g.elapsed = 0;
      g.ready = false;
      g.requested = false;
      g.decoding = false;
      g.failed = false;

      g.slides.forEach((slide, number) => {
        slide.hidden = number !== g.index;
      });

      const video = this._currentVideo();

      g.resetVideo = !!video;

      if (video?.readyState >= 1) {
        video.currentTime = 0;
        g.resetVideo = false;
      }

      if (manual && g.status) {
        const title =
          g.slides[g.index].dataset.title ||
          'Selected branding work';

        g.status.textContent =
          `Slide ${g.index + 1} of ${g.slides.length}: ${title}`;
      }

      this._syncGallery();
    }

    _decode() {
      const g = this._gallery;

      if (
        g.ready ||
        g.decoding ||
        g.failed
      ) return;

      const img = g.media[g.index];
      const version = g.version;
      const signal = this._abort.signal;

      g.decoding = true;

      let attempt;

      try {
        attempt = img.decode
          ? img.decode()
          : Promise.resolve();
      } catch (error) {
        attempt = Promise.reject(error);
      }

      const complete = () => {
        if (
          signal.aborted ||
          version !== g.version
        ) return;

        g.decoding = false;

        if (!img.naturalWidth) {
          return this._fail();
        }

        g.ready = true;
        this._syncGallery();
      };

      Promise.resolve(attempt).then(
        complete,
        complete
      );
    }

    _fail() {
      const g = this._gallery;

      g.failed = true;
      g.wanted = false;

      this._syncGallery();
    }

    _syncGallery() {
      const g = this._gallery;
      if (!g) return;

      this._stopClock();

      const media = g.media[g.index];
      const video = this._currentVideo();

      if (video) {
        if (video.error) {
          g.failed = true;
          g.wanted = false;
        }

        if (this._allowed(g) && !g.failed) {
          this._play(g, video);

          if (
            !video.paused &&
            !video.ended &&
            video.readyState >= 2
          ) {
            this._startClock();
          }
        } else {
          this._pause(g, video);
        }
      } else {
        if (!media) g.ready = true;

        if (
          media &&
          g.visible &&
          !document.hidden &&
          !g.requested &&
          !g.failed
        ) {
          g.requested = true;
          media.loading = 'eager';

          if (media.complete) {
            if (media.naturalWidth) {
              this._decode();
            } else {
              this._fail();
            }
          }
        }

        if (
          g.ready &&
          this._allowed(g) &&
          g.slides.length > 1 &&
          !g.failed
        ) {
          this._startClock();
        }
      }

      this._paintGallery();
    }

    _stopClock() {
      const g = this._gallery;
      if (!g) return;

      if (
        g.stamp !== null &&
        !this._currentVideo()
      ) {
        g.elapsed = Math.min(
          g.interval,
          g.elapsed + Math.max(
            0,
            performance.now() - g.stamp
          )
        );
      }

      g.stamp = null;

      cancelAnimationFrame(g.frame);
      g.frame = 0;
    }

    _startClock() {
      const g = this._gallery;

      this._stopClock();

      g.stamp = performance.now();

      g.frame = requestAnimationFrame(now => {
        this._tick(now);
      });
    }

    _tick(now) {
      const g = this._gallery;

      if (!g || g.stamp === null) return;

      if (!this._allowed(g)) {
        this._syncGallery();
        return;
      }

      if (!this._currentVideo()) {
        g.elapsed = Math.min(
          g.interval,
          g.elapsed + Math.max(0, now - g.stamp)
        );

        g.stamp = now;

        if (g.elapsed >= g.interval) {
          this._select(g.index + 1, false);
          return;
        }
      }

      this._paintGallery();

      g.frame = requestAnimationFrame(time => {
        this._tick(time);
      });
    }

    _paintGallery() {
      const g = this._gallery;
      if (!g) return;

      const video = this._currentVideo();

      const progress = video
        ? (
            Number.isFinite(video.duration) &&
            video.duration > 0
              ? clamp(video.currentTime / video.duration)
              : 0
          )
        : clamp(g.elapsed / g.interval);

      g.toggle.hidden =
        !video && g.slides.length < 2;

      g.toggle.disabled = g.failed;
      g.toggle.textContent = g.wanted ? 'Pause' : 'Play';

      g.toggle.setAttribute(
        'aria-label',
        g.wanted ? 'Pause slideshow' : 'Play slideshow'
      );

      g.dots.forEach((dot, index) => {
        if (index === g.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }

        const fill = dot.querySelector('[data-mb-fill]');

        if (fill) {
          const amount =
            index < g.index
              ? 1
              : index === g.index
                ? progress
                : 0;

          fill.style.transform = `scaleX(${amount})`;
        }
      });

      if (g.error) {
        g.error.hidden = !g.failed;

        g.error.textContent = g.failed
          ? 'Media unavailable. Choose another slide.'
          : '';
      }
    }

    /* LINE-BY-LINE SCROLL REVEAL */

    _setupReveal() {
      this._paragraph = this.querySelector('[data-mb-reveal]');

      if (!this._paragraph) return;

      this._original =
        this._paragraph.textContent.trim();

      if (!this._original) return;

      const fragment =
        document.createDocumentFragment();

      this._words = this._original
        .split(/\s+/)
        .map((word, index) => {
          if (index) {
            fragment.append(
              document.createTextNode(' ')
            );
          }

          const span = document.createElement('span');

          span.className = 'mb-word';
          span.textContent = word;

          fragment.append(span);
          return span;
        });

      this._paragraph.replaceChildren(fragment);

      this._on(window, 'scroll', () => {
        this._scheduleReveal();
      }, {
        passive: true
      });

      this._on(window, 'resize', () => {
        this._scheduleReveal(true);
      }, {
        passive: true
      });

      if ('ResizeObserver' in window) {
        this._resize = new ResizeObserver(() => {
          this._scheduleReveal(true);
        });

        this._resize.observe(this._paragraph);
      }

      const signal = this._abort.signal;

      document.fonts?.ready.then(() => {
        if (!signal.aborted) {
          this._scheduleReveal(true);
        }
      });

      this._scheduleReveal(true);
    }

    _scheduleReveal(measure = false) {
      if (!this._words?.length) return;

      this._measure = this._measure || measure;

      if (this._revealFrame) return;

      this._revealFrame = requestAnimationFrame(() => {
        this._revealFrame = 0;

        if (this._measure) {
          this._rows = [];

          this._words.forEach(span => {
            const rect = span.getBoundingClientRect();

            let row =
              this._rows[this._rows.length - 1];

            if (
              !row ||
              Math.abs(row.top - rect.top) > 2
            ) {
              row = {
                top: rect.top,
                left: rect.left,
                right: rect.right,
                words: []
              };

              this._rows.push(row);
            }

            row.right = Math.max(
              row.right,
              rect.right
            );

            row.words.push({
              span,
              left: rect.left,
              width: rect.width
            });
          });

          this._measure = false;
        }

        const rect =
          this._paragraph.getBoundingClientRect();

        const viewport = window.innerHeight;

        const progress = this._motion.matches
          ? 1
          : clamp(
              (viewport * .82 - rect.top) /
              (rect.height + viewport * .27)
            );

        this._rows.forEach((row, index) => {
          const edge =
            row.left +
            (row.right - row.left) *
            clamp(
              progress * this._rows.length - index
            );

          row.words.forEach(word => {
            const fill = clamp(
              (edge - word.left) /
              (word.width || 1)
            );

            word.span.style.setProperty(
              '--mb-ink',
              `${(fill * 100).toFixed(2)}%`
            );
          });
        });
      });
    }

    /* CLEANUP WHEN SHOPIFY RELOADS THE SECTION */

    disconnectedCallback() {
      cancelAnimationFrame(this._mountFrame);
      cancelAnimationFrame(this._revealFrame);

      this._mountFrame = 0;
      this._revealFrame = 0;

      this._abort?.abort();
      this._observer?.disconnect();
      this._resize?.disconnect();

      this._stopClock();

      this.querySelectorAll('video').forEach(video => {
        video.pause();
        video.controls = true;
      });

      if (this._hero) {
        this._hero.toggle.hidden = true;
      }

      if (this._gallery) {
        this._gallery.ui.hidden = true;
      }

      if (
        this._paragraph &&
        this._original !== undefined
      ) {
        this._paragraph.textContent = this._original;
      }

      this._abort = null;
      this._hero = null;
      this._gallery = null;
      this._paragraph = null;
      this._words = null;
    }
  }

  customElements.define(
    'manet-branding',
    ManetBranding
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fifaworldcup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.bold-lifestyle-finance-section');
    if (section) {
      console.log('Bold Lifestyle x Finance section loaded');
      
      // Button interaction
      const ctaButton = section.querySelector('.cta-button');
      if (ctaButton) {
        ctaButton.addEventListener('click', function() {
          window.open('https://calendly.com/matvey777333/free-consultation', '_blank');
        });
      }
      
      // Animate coordinate ticker
      const coordinateTicker = section.querySelector('.coordinate-ticker');
      if (coordinateTicker) {
        const locations = [
          "LAT: 45.523064° | LNG: -122.676483° | ALT: 39,000 FT | SPD: 814 KMH",
          "LAT: 45.505106° | LNG: -122.627975° | ALT: 37,000 FT | SPD: 832 KMH",
          "LAT: 45.512230° | LNG: -122.658722° | ALT: 38,500 FT | SPD: 798 KMH"
        ];
        
        let currentIndex = 0;
        setInterval(() => {
          currentIndex = (currentIndex + 1) % locations.length;
          coordinateTicker.textContent = "— EXEC ROUTE TRACKING ENABLED — " + locations[currentIndex];
        }, 3000);
      }
      
      // Add hover effect to passport stamps
      const stamps = section.querySelectorAll('.passport-stamp');
      stamps.forEach((stamp, index) => {
        if (index === 0) {
          stamp.textContent = "ALT∆IR";
        } else if (index === 1) {
          stamp.textContent = "DROP 02";
        } else {
          stamp.textContent = "2025";
        }
        
        stamp.addEventListener('mouseenter', function() {
          this.style.transform = this.style.transform.replace('rotate', 'scale(1.1) rotate');
          this.style.borderColor = 'rgba(255,255,255,0.1)';
          this.style.color = 'rgba(255,255,255,0.1)';
        });
        
        stamp.addEventListener('mouseleave', function() {
          this.style.transform = this.style.transform.replace('scale(1.1) ', '');
          this.style.borderColor = 'rgba(255,255,255,0.03)';
          this.style.color = 'rgba(255,255,255,0.03)';
        });
      });
      
      // Access Pill functionality
      const accessPill = section.querySelector('.access-pill');
      if (accessPill) {
        const pillStatus = accessPill.querySelector('.pill-status');
        const statusMessages = [
          "STATUS: VERIFIED",
          "STATUS: ACTIVE",
          "STATUS: EXEC MODE",
          "STATUS: GLOBAL ACCESS",
          "STATUS: ALT∆IR VERIFIED"
        ];
        
        let currentStatus = 0;
        setInterval(() => {
          currentStatus = (currentStatus + 1) % statusMessages.length;
          pillStatus.textContent = statusMessages[currentStatus];
          
          pillStatus.style.opacity = '0';
          setTimeout(() => {
            pillStatus.style.opacity = '0.7';
          }, 100);
        }, 3000);
        
        accessPill.addEventListener('mouseenter', () => {
          accessPill.style.animation = 'pulse-fade 1s ease-out, glitch-flicker 0.5s infinite alternate';
        });
        
        accessPill.addEventListener('mouseleave', () => {
          accessPill.style.animation = 'pulse-fade 1s ease-out, glitch-flicker 5s infinite alternate';
        });
      }
    }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gptsection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var cards = document.querySelectorAll('#altair-animated-metrics .metric-card');
    var observerOptions = {
      threshold: 0.4
    };

    var observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          animateNumber(entry.target.querySelector('.chart-number'));
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    cards.forEach(function(card) {
      observer.observe(card);
    });

    function animateNumber(el) {
      var target = parseFloat(el.getAttribute('data-target'));
      var current = 0;
      var duration = 1200; // animation duration in ms
      var startTime = null;
      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = timestamp - startTime;
        var percent = Math.min(progress / duration, 1);
        var value = Math.floor(percent * target);
        el.firstChild.textContent = value;
        if (percent < 1) {
          requestAnimationFrame(step);
        } else {
          el.firstChild.textContent = target;
        }
      }
      requestAnimationFrame(step);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const altairText = document.getElementById('altair-header-text');
  if (!altairText) return;
  
  const isHomepage = window.location.pathname === '/' || window.location.pathname === '';
  
  if (isHomepage) {
    altairText.style.display = 'none';
    return;
  }
  
  altairText.style.display = 'block';
  
  const allElements = document.querySelectorAll('*');
  const sectionsWithTheme = [];
  
  allElements.forEach(el => {
    if (el.hasAttribute('data-theme')) {
      sectionsWithTheme.push(el);
    }
  });
  
  if (sectionsWithTheme.length === 0) {
    return;
  }
  
  let currentTheme = null;
  
  const observer = new IntersectionObserver((entries) => {
    let hasIntersection = false;
    let intersectedTheme = null;
    
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        hasIntersection = true;
        const theme = entry.target.dataset.theme;
        
        if (theme) {
          intersectedTheme = theme;
        }
      }
    });
    
    if (hasIntersection && intersectedTheme) {
      currentTheme = intersectedTheme;
      const shouldInvert = intersectedTheme === 'light';
      altairText.classList.toggle('invert', shouldInvert);
    } 
    else if (hasIntersection && !intersectedTheme) {
      currentTheme = null;
      altairText.classList.remove('invert');
    }
    else if (!hasIntersection) {
      const scrollTop = window.scrollY;
      if (scrollTop < 100) {
        altairText.classList.remove('invert');
      }
    }
    
  }, {
    rootMargin: '-80px 0px 0px 0px',
    threshold: 0.1
  });
  
  sectionsWithTheme.forEach(element => observer.observe(element));
  
  const firstElements = document.querySelectorAll('section, div[class], main > *');
  const elementsToObserve = Array.from(firstElements).slice(0, 10);
  
  elementsToObserve.forEach(el => {
    if (!sectionsWithTheme.includes(el) && !el.hasAttribute('data-theme')) {
      observer.observe(el);
    }
  });
});

class StickyHeader extends HTMLElement{
  constructor(){super()}
  connectedCallback(){
    this.header=document.querySelector('.section-header');
    this.headerIsAlwaysSticky=this.getAttribute('data-sticky-type')==='always'||this.getAttribute('data-sticky-type')==='reduce-logo-size';
    this.headerBounds={};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change',this.setHeaderHeight.bind(this));
    if(this.headerIsAlwaysSticky){this.header.classList.add('shopify-section-header-sticky')}
    this.currentScrollTop=0;
    this.preventReveal=false;
    this.predictiveSearch=this.querySelector('predictive-search');
    this.onScrollHandler=this.onScroll.bind(this);
    this.hideHeaderOnScrollUp=()=>this.preventReveal=true;
    this.addEventListener('preventHeaderReveal',this.hideHeaderOnScrollUp);
    window.addEventListener('scroll',this.onScrollHandler,{passive:true});
    this.createObserver();
  }
  setHeaderHeight(){
    if(this.header){
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }
  disconnectedCallback(){this.removeEventListener('preventHeaderReveal',this.hideHeaderOnScrollUp);window.removeEventListener('scroll',this.onScrollHandler)}
  createObserver(){let o=new IntersectionObserver((e,o)=>{this.headerBounds=e[0].intersectionRect;o.disconnect()},{rootMargin: '0px 0px -100% 0px'});o.observe(this.header)}
  onScroll(){
    const y=window.pageYOffset||document.documentElement.scrollTop;
    if(this.predictiveSearch&&this.predictiveSearch.isOpen)return;
    if(y>this.currentScrollTop&&y>this.headerBounds.bottom){
      this.header.classList.add('scrolled-past-header');
      if(this.preventHide)return;
      requestAnimationFrame(this.hide.bind(this));
    }else if(y<this.currentScrollTop&&y>this.headerBounds.bottom){
      this.header.classList.add('scrolled-past-header');
      if(!this.preventReveal){requestAnimationFrame(this.reveal.bind(this))}
      else{window.clearTimeout(this.isScrolling);this.isScrolling=setTimeout(()=>{this.preventReveal=false},66);requestAnimationFrame(this.hide.bind(this))}
    }else if(y<=this.headerBounds.top){
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this))
    }
    this.currentScrollTop=y
  }
  hide(){if(this.headerIsAlwaysSticky)return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal()}
  reveal(){if(this.headerIsAlwaysSticky)return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden')}
  reset(){if(this.headerIsAlwaysSticky)return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate')}
  closeMenuDisclosure(){this.disclosures=this.disclosures||this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d=>d.close())}
  closeSearchModal(){this.searchModal=this.searchModal||this.header.querySelector('details-modal'); this.searchModal && this.searchModal.close(false)}
}
customElements.define('sticky-header',StickyHeader);

document.addEventListener('DOMContentLoaded', function(){
  const openBtn = document.querySelector('#apMenuTrigger');
  const drawer  = document.querySelector('#apMenuDrawer');
  if(!openBtn || !drawer) return;

  const html = document.documentElement;
  const panel = drawer.querySelector('.ap-panel');
  const closers = drawer.querySelectorAll('[data-ap-close], .ap-menu-close');
  let lastFocused = null;
  let isAnimating = false;

  const getFocusable = (root) => root.querySelectorAll(
    'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), textarea:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
  );

  function setExpanded(val){
    openBtn.setAttribute('aria-expanded', val ? 'true' : 'false');
    openBtn.classList.toggle('is-open', val);
    openBtn.setAttribute('aria-label', val ? 'Close main menu' : 'Open main menu');
  }

  function open(){
    if (isAnimating || drawer.getAttribute('aria-hidden') === 'false') return;

    isAnimating = true;
    lastFocused = document.activeElement;

    drawer.classList.remove('is-closing');
    drawer.setAttribute('aria-hidden', 'false');
    setExpanded(true);
    html.setAttribute('data-drawer-open', 'true');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const focusables = getFocusable(panel);
        if (focusables.length) {
          focusables[0].focus();
        }
        setTimeout(() => {
          isAnimating = false;
        }, 980);
      });
    });
  }

  function close(){
    if (isAnimating || drawer.getAttribute('aria-hidden') === 'true') return;

    isAnimating = true;
    drawer.classList.add('is-closing');
    setExpanded(false);

    setTimeout(() => {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-closing');
      html.removeAttribute('data-drawer-open');

      if (lastFocused && document.body.contains(lastFocused)) {
        openBtn.focus();
      }

      isAnimating = false;
    }, 420);
  }

  openBtn.addEventListener('click', () => {
    if (drawer.getAttribute('aria-hidden') === 'false') {
      close();
    } else {
      open();
    }
  });

  closers.forEach(el => el.addEventListener('click', close));
  
  document.addEventListener('keydown', (e) => {
    if (drawer.getAttribute('aria-hidden') === 'false') {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      }

      if (e.key === 'Tab') {
        const focusables = Array.from(getFocusable(panel)).filter(el => {
          return el.offsetParent !== null || el === document.activeElement;
        });
        
        if (!focusables.length) return;
        
        const first = focusables[0];
        const last  = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); 
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); 
          first.focus();
        }
      }
    }
  });

  const backdrop = drawer.querySelector('.ap-backdrop');
  if (backdrop) backdrop.addEventListener('click', close);

  drawer.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (link && link.getAttribute('href')?.startsWith('/')) {
      setTimeout(close, 300);
    }
  });

  // PREVIEW LOGIC
  const preview = drawer.querySelector('.ap-menu-preview');
  const previewImg = drawer.querySelector('.ap-preview-image');
  const previewText = drawer.querySelector('.ap-preview-text');
  const menuLinks = Array.from(drawer.querySelectorAll('.ap-menu-list .ap-menu-link'));

  if (preview && previewImg && previewText && menuLinks.length) {
    const previewData = {
      1: {
        type: 'image',
        position: 'right',
        value: 'https://cdn.shopify.com/s/files/1/0550/1183/5979/files/ChatGPT_Image_Jan_5_2026_at_08_12_52_PM.png?v=1767672915'
      },
      2: {
        type: 'text',
        position: 'left',
        value: 'Inspired by the rupture that Édouard Manet created'
      },
      3: {
        type: 'image',
        position: 'right',
        value: 'https://cdn.shopify.com/s/files/1/0550/1183/5979/files/2025_RECAP-3.png?v=1771823228'
      },
      4: {
        type: 'image',
        position: 'left',
        value: 'https://cdn.shopify.com/s/files/1/0550/1183/5979/files/68_e2d43cdb-ce29-4734-aa6a-9677ea6b473a.png?v=1771738888'
      },
      5: {
        type: 'image',
        position: 'right',
        value: 'https://cdn.shopify.com/s/files/1/0550/1183/5979/files/c1c5169b8fb321c63d835eca55d81877.jpg?v=1772093436'
      }
    };

    function clearPreview() {
      preview.classList.remove('is-visible', 'pos-left', 'pos-right');
      previewImg.style.display = 'none';
      previewText.style.display = 'none';
      previewImg.src = '';
      previewText.textContent = '';
    }

    function showPreview(index) {
      const item = previewData[index];
      if (!item) {
        clearPreview();
        return;
      }

      preview.classList.remove('pos-left', 'pos-right');
      preview.classList.add('is-visible', item.position === 'left' ? 'pos-left' : 'pos-right');

      if (item.type === 'image') {
        previewText.style.display = 'none';
        previewImg.style.display = 'block';
        previewImg.src = item.value;
        previewImg.alt = 'Menu preview';
      } else {
        previewImg.style.display = 'none';
        previewText.style.display = 'block';
        previewText.textContent = item.value;
      }
    }

    menuLinks.forEach((link, idx) => {
      link.addEventListener('mouseenter', () => showPreview(idx));
      link.addEventListener('focus', () => showPreview(idx));
    });

    const list = drawer.querySelector('.ap-menu-list');
    if (list) {
      list.addEventListener('mouseleave', clearPreview);
    }

    closers.forEach(el => {
      el.addEventListener('click', clearPreview);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manet-small-business"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('manet-small-business')) return;

  const clamp = n => Math.max(0, Math.min(1, n));

  class ManetSmallBusiness extends HTMLElement {
    connectedCallback() {
      if (this._abort || this._mountFrame) return;

      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;

        if (this.isConnected) {
          this._mount();
        }
      });
    }

    _mount() {
      if (this.dataset.sbReveal !== 'true') return;

      this._paragraph = this.querySelector('[data-sb-text]');

      if (!this._paragraph) return;

      this._original = this._paragraph.textContent;

      const text = this._original.trim();

      if (!text) return;

      this._abort = new AbortController();

      const signal = this._abort.signal;

      this._motion = matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      const fragment = document.createDocumentFragment();

      this._words = text.split(/\s+/).map((word, index) => {
        if (index) {
          fragment.append(document.createTextNode(' '));
        }

        const span = document.createElement('span');

        span.className = 'manet-sb__word';
        span.textContent = word;

        fragment.append(span);

        return span;
      });

      this._paragraph.replaceChildren(fragment);

      const schedule = () => this._schedule();
      const measure = () => this._schedule(true);

      window.addEventListener('scroll', schedule, {
        passive: true,
        signal
      });

      window.addEventListener('resize', measure, {
        passive: true,
        signal
      });

      this._motion.addEventListener('change', measure, {
        signal
      });

      if ('ResizeObserver' in window) {
        this._resize = new ResizeObserver(measure);
        this._resize.observe(this._paragraph);
      }

      document.fonts?.ready.then(() => {
        if (!signal.aborted) {
          measure();
        }
      });

      measure();
    }

    _schedule(measure = false) {
      if (!this._words?.length) return;

      this._needsMeasure = this._needsMeasure || measure;

      if (this._frame) return;

      this._frame = requestAnimationFrame(() => {
        this._frame = 0;

        if (this._needsMeasure) {
          this._rows = [];

          this._words.forEach(span => {
            const rect = span.getBoundingClientRect();

            let row = this._rows[this._rows.length - 1];

            if (
              !row ||
              Math.abs(row.top - rect.top) > 2
            ) {
              row = {
                top: rect.top,
                left: rect.left,
                right: rect.right,
                words: []
              };

              this._rows.push(row);
            }

            row.right = Math.max(row.right, rect.right);

            row.words.push({
              span,
              left: rect.left,
              width: rect.width
            });
          });

          this._needsMeasure = false;
        }

        const rect = this._paragraph.getBoundingClientRect();
        const viewport = window.innerHeight;

        const progress = this._motion.matches
          ? 1
          : clamp(
              (viewport * .82 - rect.top) /
              (rect.height + viewport * .27)
            );

        this._rows.forEach((row, index) => {
          const edge =
            row.left +
            (row.right - row.left) *
            clamp(progress * this._rows.length - index);

          row.words.forEach(word => {
            const fill = clamp(
              (edge - word.left) / (word.width || 1)
            );

            word.span.style.setProperty(
              '--sb-ink',
              `${(fill * 100).toFixed(2)}%`
            );
          });
        });
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._mountFrame);
      cancelAnimationFrame(this._frame);

      this._abort?.abort();
      this._resize?.disconnect();

      if (
        this._paragraph &&
        this._original !== undefined
      ) {
        this._paragraph.textContent = this._original;
      }

      this._mountFrame = 0;
      this._frame = 0;
      this._abort = null;
      this._paragraph = null;
      this._words = null;
    }
  }

  customElements.define(
    'manet-small-business',
    ManetSmallBusiness
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-landindtest2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Location tracker animation
    const locationTracker = document.querySelector('.location-tracker');
    if (locationTracker) {
      const locations = [
        "LAT: 34.052235° | LNG: -118.243683° | ALT: 0 FT | SPD: 0 KMH",
        "LAT: 25.204849° | LNG: 55.270782° | ALT: 0 FT | SPD: 0 KMH",
        "LAT: 40.712776° | LNG: -74.005974° | ALT: 0 FT | SPD: 0 KMH"
      ];
      
      let currentIndex = 0;
      setInterval(() => {
        currentIndex = (currentIndex + 1) % locations.length;
        locationTracker.textContent = "— GLOBAL POSITION TRACKING — " + locations[currentIndex];
      }, 3000);
    }
    
    // Access badge status rotation
    const accessBadge = document.querySelector('.access-badge');
    if (accessBadge) {
      const badgeStatus = accessBadge.querySelector('.badge-status');
      const statusMessages = [
        "STATUS: VERIFIED",
        "STATUS: ACTIVE",
        "STATUS: MOBILITY MODE",
        "STATUS: GLOBAL ACCESS",
        "STATUS: ALT∆IR VERIFIED"
      ];
      
      let currentStatus = 0;
      setInterval(() => {
        currentStatus = (currentStatus + 1) % statusMessages.length;
        badgeStatus.textContent = statusMessages[currentStatus];
        
        badgeStatus.style.opacity = '0';
        setTimeout(() => {
          badgeStatus.style.opacity = '0.7';
        }, 100);
      }, 3000);
    }
    
    // Security badges hover effect
    document.querySelectorAll('.security-badge').forEach(badge => {
      badge.addEventListener('mouseenter', () => {
        badge.style.transform = 'scale(1.1)';
        badge.style.borderColor = 'rgba(255,255,255,0.1)';
        badge.style.color = 'rgba(255,255,255,0.1)';
      });
      
      badge.addEventListener('mouseleave', () => {
        badge.style.transform = '';
        badge.style.borderColor = 'rgba(255,255,255,0.03)';
        badge.style.color = 'rgba(255,255,255,0.03)';
      });
    });
    
    // Button click handler
    document.querySelectorAll('.mobility-button').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.open('https://altairpartner.com/pages/altair-global-mobility', '_blank');
      });
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricingpage"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('manet-pricing')) return;

  const clamp = value => Math.max(0, Math.min(1, value));

  class ManetPricing extends HTMLElement {
    connectedCallback() {
      if (this._abort || this._mountFrame) return;

      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;

        if (this.isConnected) {
          this._mount();
        }
      });
    }

    _mount() {
      this._abort = new AbortController();

      const signal = this._abort.signal;

      this._motion = matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');

        if (
          !link ||
          event.ctrlKey ||
          event.metaKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        const target = document.getElementById(
          link.getAttribute('href').slice(1)
        );

        if (!target || !this.contains(target)) {
          return;
        }

        event.preventDefault();

        target.scrollIntoView({
          behavior: this._motion.matches ? 'instant' : 'smooth',
          block: 'start'
        });

        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
        }

        target.focus({
          preventScroll: true
        });
      }, {
        signal
      });

      if (this.dataset.mpReveal !== 'true') return;

      this._paragraph = this.querySelector('[data-mp-text]');

      if (!this._paragraph) return;

      this._original = this._paragraph.textContent;

      const text = this._original.trim();

      if (!text) return;

      const fragment = document.createDocumentFragment();

      this._words = text.split(/\s+/).map((word, index) => {
        if (index) {
          fragment.append(document.createTextNode(' '));
        }

        const span = document.createElement('span');

        span.className = 'mp-word';
        span.textContent = word;

        fragment.append(span);

        return span;
      });

      this._paragraph.replaceChildren(fragment);

      const measure = () => this._schedule(true);

      window.addEventListener(
        'scroll',
        () => this._schedule(),
        {
          passive: true,
          signal
        }
      );

      window.addEventListener(
        'resize',
        measure,
        {
          passive: true,
          signal
        }
      );

      this._motion.addEventListener(
        'change',
        measure,
        {
          signal
        }
      );

      if ('ResizeObserver' in window) {
        this._resize = new ResizeObserver(measure);
        this._resize.observe(this._paragraph);
      }

      document.fonts?.ready.then(() => {
        if (!signal.aborted) {
          measure();
        }
      });

      measure();
    }

    _schedule(measure = false) {
      if (!this._words?.length) return;

      this._needsMeasure = this._needsMeasure || measure;

      if (this._frame) return;

      this._frame = requestAnimationFrame(() => {
        this._frame = 0;

        if (this._needsMeasure) {
          this._rows = [];

          this._words.forEach(span => {
            const rect = span.getBoundingClientRect();

            let row = this._rows[this._rows.length - 1];

            if (
              !row ||
              Math.abs(row.top - rect.top) > 2
            ) {
              row = {
                top: rect.top,
                left: rect.left,
                right: rect.right,
                words: []
              };

              this._rows.push(row);
            }

            row.right = Math.max(row.right, rect.right);

            row.words.push({
              span,
              left: rect.left,
              width: rect.width
            });
          });

          this._needsMeasure = false;
        }

        const rect = this._paragraph.getBoundingClientRect();
        const viewport = window.innerHeight;

        const progress = this._motion.matches
          ? 1
          : clamp(
              (viewport * .82 - rect.top) /
              (rect.height + viewport * .27)
            );

        this._rows.forEach((row, index) => {
          const edge =
            row.left +
            (row.right - row.left) *
            clamp(progress * this._rows.length - index);

          row.words.forEach(word => {
            const fill = clamp(
              (edge - word.left) / (word.width || 1)
            );

            word.span.style.setProperty(
              '--mp-ink',
              `${(fill * 100).toFixed(2)}%`
            );
          });
        });
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._mountFrame);
      cancelAnimationFrame(this._frame);

      this._abort?.abort();
      this._resize?.disconnect();

      this.querySelectorAll('video').forEach(video => {
        video.pause();
      });

      if (
        this._paragraph &&
        this._original !== undefined
      ) {
        this._paragraph.textContent = this._original;
      }

      this._mountFrame = 0;
      this._frame = 0;
      this._abort = null;
      this._paragraph = null;
      this._words = null;
    }
  }

  customElements.define(
    'manet-pricing',
    ManetPricing
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel3"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Create terminal lines
  const financeSection = document.querySelector('.altair-finance');
  for (let i = 0; i < 4; i++) {
    const line = document.createElement('div');
    line.className = 'terminal-line';
    financeSection.appendChild(line);
  }
  
  // Simulate live data updates
  const indexValue = document.querySelector('.index-value');
  if (indexValue) {
    setInterval(() => {
      const currentValue = parseFloat(indexValue.textContent.split(' ')[1]);
      const newValue = (currentValue + (Math.random() * 0.4 - 0.2)).toFixed(1);
      indexValue.textContent = `${Math.random() > 0.5 ? '↑' : '↓'} ${newValue} pts`;
      
      // Change color based on direction
      if (indexValue.textContent.includes('↑')) {
        indexValue.style.color = '#4caf50'; // Green
      } else {
        indexValue.style.color = '#f44336'; // Red
      }
    }, 5000);
  }
  
  // Currency ticker effect
  const currencyValues = document.querySelectorAll('.currency-row span:last-child');
  currencyValues.forEach(value => {
    const originalValue = value.textContent;
    setInterval(() => {
      if (Math.random() > 0.7) { // 30% chance to "update"
        if (value.textContent === originalValue) {
          value.textContent = (parseFloat(originalValue) + (Math.random() * 0.1 - 0.05)).toFixed(2);
        } else {
          value.textContent = originalValue;
        }
      }
    }, 3000);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travelrotation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const orbitTrack = document.querySelector('.orbit-track');
  const videoContainers = Array.from(document.querySelectorAll('.video-container'));
  const leftBtn = document.querySelector('.arrow.left');
  const rightBtn = document.querySelector('.arrow.right');
  const counter = document.querySelector('.orbit-counter');
  
  let currentAngle = 0;
  const totalVideos = videoContainers.length;
  const angleIncrement = 360 / totalVideos;
  let currentIndex = 0;
  
  // Particle canvas setup
  const particleCanvas = document.getElementById('particle-layer');
  const ctx = particleCanvas.getContext('2d');
  particleCanvas.width = window.innerWidth;
  particleCanvas.height = window.innerHeight;
  
  // Create particles
  const particles = [];
  const particleCount = 80;
  
  for (let i = 0; i < particleCount; i++) {
    particles.push({
      x: Math.random() * particleCanvas.width,
      y: Math.random() * particleCanvas.height,
      size: Math.random() * 2 + 0.5,
      speedX: (Math.random() - 0.5) * 0.2,
      speedY: (Math.random() - 0.5) * 0.2,
      opacity: Math.random() * 0.5 + 0.1
    });
  }
  
  // Animate particles
  function animateParticles() {
    ctx.clearRect(0, 0, particleCanvas.width, particleCanvas.height);
    
    particles.forEach(particle => {
      ctx.beginPath();
      ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(255, 255, 255, ${particle.opacity})`;
      ctx.fill();
      
      // Move particles
      particle.x += particle.speedX;
      particle.y += particle.speedY;
      
      // Reset particles that go off screen
      if (particle.x < 0 || particle.x > particleCanvas.width || 
          particle.y < 0 || particle.y > particleCanvas.height) {
        particle.x = Math.random() * particleCanvas.width;
        particle.y = Math.random() * particleCanvas.height;
      }
    });
    
    requestAnimationFrame(animateParticles);
  }
  
  animateParticles();
  
  // Auto-rotate pulse effect
  let pulseAngle = 0;
  function autoPulse() {
    pulseAngle += 0.002;
    const pulseOffset = Math.sin(pulseAngle) * 0.5;
    
    videoContainers.forEach((container, index) => {
      const currentRotateY = (index * angleIncrement + currentAngle) % 360;
      const pulseEffect = Math.sin(currentRotateY * Math.PI / 180 + pulseAngle) * 2;
      
      if (index !== currentIndex) {
        container.style.transform = `rotateY(${currentRotateY}deg) translateZ(${600 + pulseEffect}px)`;
      }
    });
    
    requestAnimationFrame(autoPulse);
  }
  
  autoPulse();
  
  // Rotate the carousel
  function rotateCarousel(angle) {
    currentAngle += angle;
    orbitTrack.style.transform = `rotateY(${currentAngle}deg)`;
    
    // Update current index
    currentIndex = (currentIndex - angle/angleIncrement + totalVideos) % totalVideos;
    counter.textContent = `VIDEO ${currentIndex + 1} / ${totalVideos}`;
    
    // Update depth scaling
    updateDepthScaling();
    
    // Autoplay center video
    autoplayCenterVideo();
  }
  
  // Update depth scaling
  function updateDepthScaling() {
    videoContainers.forEach((container, index) => {
      const diff = (index - currentIndex + totalVideos) % totalVideos;
      const distance = Math.min(diff, totalVideos - diff);
      
      // Calculate opacity and z-index based on distance from center
      const opacity = 1 - (distance * 0.1);
      const zIndex = 10 - distance;
      
      container.style.opacity = opacity;
      container.style.zIndex = zIndex;
    });
  }
  
  // Autoplay center video
  function autoplayCenterVideo() {
    const centerIndex = currentIndex;
    videoContainers.forEach((container, index) => {
      const iframe = container.querySelector('iframe');
      if (iframe) {
        if (index === centerIndex) {
          // Play center video
          const src = iframe.src;
          if (!src.includes('autoplay=1')) {
            iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1&mute=1';
          }
        } else {
          // Pause other videos
          iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
      }
    });
  }
  
  // Button events
  leftBtn.addEventListener('click', () => rotateCarousel(-angleIncrement));
  rightBtn.addEventListener('click', () => rotateCarousel(angleIncrement));
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') {
      rotateCarousel(-angleIncrement);
    } else if (e.key === 'ArrowRight') {
      rotateCarousel(angleIncrement);
    }
  });
  
  // Touch events for mobile swipe
  let touchStartX = 0;
  let touchEndX = 0;
  
  document.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, false);
  
  document.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  }, false);
  
  function handleSwipe() {
    const threshold = 50; // Minimum swipe distance
    
    if (touchEndX < touchStartX - threshold) {
      rotateCarousel(angleIncrement); // Swipe left to go right
    } else if (touchEndX > touchStartX + threshold) {
      rotateCarousel(-angleIncrement); // Swipe right to go left
    }
  }
  
  // Initialize counter and scaling
  counter.textContent = `VIDEO 1 / ${totalVideos}`;
  updateDepthScaling();
  
  // Autoplay first video
  autoplayCenterVideo();
  
  // Resize handler
  window.addEventListener('resize', function() {
    particleCanvas.width = window.innerWidth;
    particleCanvas.height = window.innerHeight;
  });
});

  } catch(e) { console.error(e); }
})();
})();
